export type ClassValue = string | false | null | undefined;

/**
 * Join class names, dropping falsy ones.
 *
 * Deliberately not `tailwind-merge`. That library exists to resolve *conflicts*
 * (`px-2` beating an earlier `px-4`), which only matters if callers routinely
 * override a component's own spacing and colour. The primitives here take that
 * job through `variant`/`size` props instead, so `className` is for additive
 * things — margin, width, grid placement — where a plain join is correct and
 * costs nothing.
 *
 * The consequence to remember: class order in the attribute does not decide the
 * winner, stylesheet order does. If you find yourself passing `className` to
 * fight a variant, add or fix the variant.
 */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
